type ChevronDownProps = {
  className?: string;
};

const ChevronDown = ({ className, ...props }: ChevronDownProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g id="Icon/Expand/24dp">
      <path
        id="Vector"
        d="M12.0008 15.9499C11.8674 15.9499 11.7424 15.9291 11.6258 15.8874C11.5091 15.8457 11.4008 15.7749 11.3008 15.6749L6.70078 11.0749C6.51745 10.8916 6.42578 10.6582 6.42578 10.3749C6.42578 10.0916 6.51745 9.85824 6.70078 9.6749C6.88411 9.49157 7.11745 9.3999 7.40078 9.3999C7.68411 9.3999 7.91745 9.49157 8.10078 9.6749L12.0008 13.5749L15.9008 9.6749C16.0841 9.49157 16.3174 9.3999 16.6008 9.3999C16.8841 9.3999 17.1174 9.49157 17.3008 9.6749C17.4841 9.85824 17.5758 10.0916 17.5758 10.3749C17.5758 10.6582 17.4841 10.8916 17.3008 11.0749L12.7008 15.6749C12.6008 15.7749 12.4924 15.8457 12.3758 15.8874C12.2591 15.9291 12.1341 15.9499 12.0008 15.9499Z"
        fill="#212121"
      />
    </g>
  </svg>
);

export default ChevronDown;
